import Images from './images';

export {
  Images
};



// WEBPACK FOOTER //
// ./src/style/index.js